import { render, staticRenderFns } from "./AudioTranscript.vue?vue&type=template&id=deb91060"
import script from "./AudioTranscript.vue?vue&type=script&lang=js"
export * from "./AudioTranscript.vue?vue&type=script&lang=js"
import style0 from "./AudioTranscript.vue?vue&type=style&index=0&id=deb91060&prod&lang=scss"
import style1 from "./AudioTranscript.vue?vue&type=style&index=1&id=deb91060&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports